import { useContext, useRef } from 'react';
import {
  AbortableFetch,
  abortableFetch,
  DetailContext,
  ScheduleContext,
  SnackbarContext,
  useEventCallback,
} from '@eas/common-web';
import { Messages } from '@enums';

const deactivateJob = (jobUrl: string, id: string) => {
  return abortableFetch(`${jobUrl}/${id}/active`, {
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    method: 'DELETE',
  });
};

export function useDeactivateDialog() {
  const { source, refreshAll } = useContext(DetailContext);
  const { jobUrl } = useContext(ScheduleContext);
  const { showSnackbar } = useContext(SnackbarContext);

  const fetch = useRef<AbortableFetch | null>(null);

  const callApi = useEventCallback(async () => {
    try {
      source.setLoading(true);

      if (fetch.current !== null) {
        fetch.current.abort();
      }

      fetch.current = deactivateJob(jobUrl, source.data.id);

      await fetch.current.none();
      refreshAll();
    } catch (err) {
      const message = Messages.Common.ERROR;

      showSnackbar(...message);
      return undefined;
    } finally {
      source.setLoading(false);
    }
  });

  const showButton = source.data?.active;

  return { callApi, showButton };
}
